@if (design === 'circular') {
  <svg class="circular" viewBox="25 25 50 50">
    <circle class="path" [class.light]="background === 'dark' || background === 'mixed'" [class.shadow]="background === 'mixed'" cx="50" cy="50" r="20" fill="none" stroke-width="5" stroke-miterlimit="5"/>
  </svg>
} @else {
  <div class="line line-1"></div>
  <div class="line line-2"></div>
}
